import store from 'store2';
import { KEY_EMAIL_EVENTS_STORAGE, KEY_EMAIL_INFO_STORAGE } from '~/constants';
import { getFromLocalStorage, saveToLocalStorage } from '~/helpers/storage';

export const setUserData = (userData: IUserDataForEvent) => {
  store(KEY_EMAIL_INFO_STORAGE, userData);
};

export const getUserData = (): IUserDataForEvent => {
  return store(KEY_EMAIL_INFO_STORAGE);
};

export const getMailingEvents = () => {
  return getFromLocalStorage<IMailingEventData[]>(
    KEY_EMAIL_EVENTS_STORAGE,
    'events'
  );
};

export const saveInMailingEvents = (mailingEvents: {type: string, detail: any}[]) => {
  saveToLocalStorage(KEY_EMAIL_EVENTS_STORAGE, 'events', mailingEvents);
};

export const saveMailingEventToLocalStorage = (type: string, detail: any) => {
  const mailingEvents = getMailingEvents() ?? [];
  mailingEvents.push({
    type,
    detail,
  });
  saveToLocalStorage(KEY_EMAIL_EVENTS_STORAGE, 'events', mailingEvents);
};